import * as React from "react";
import classNames from "classnames";
import { Banner } from "@grandvisionhq/content";
import { Heading, Text } from "@grandvisionhq/elements";
import { withEditableContent } from "../../hocs/hocs/with-editable-content.js";
import { CmsContentBreadcrumbs } from "../../containers/Breadcrumbs/ContentBreadcrumbs/containers/Breadcrumbs/ContentBreadcrumbs/ContentBreadcrumbs.js";
import CmsContentBlocks from "../../containers/ContentBlocks/containers/ContentBlocks/ContentBlocks.js";
import { parseBloomreachImage } from "../../utils/utils/parse-bloomreach-image.js";
const CmsContentLayout = ({ content, pageName, hasBreadcrumbs }) => {
  const { contentBlocks, coverImage, summary, title, url, displayName } = content;
  const image = parseBloomreachImage(coverImage);
  const isBrandPage = pageName === "brand-detail";
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames("content-layout", {
        "content-layout--brand": isBrandPage
      })
    },
    hasBreadcrumbs && /* @__PURE__ */ React.createElement(CmsContentBreadcrumbs, { documentName: displayName, url }),
    image && /* @__PURE__ */ React.createElement(Banner, { useContainer: true, image: image.original, mobileImage: image.mobile }),
    title && /* @__PURE__ */ React.createElement(
      Heading,
      {
        variant: "large",
        className: "content-layout__title",
        align: isBrandPage ? "center" : "left"
      },
      title
    ),
    summary && /* @__PURE__ */ React.createElement("div", { className: "content-layout__summary rich-text-area" }, /* @__PURE__ */ React.createElement(Text, { align: isBrandPage ? "center" : "left" }, summary)),
    /* @__PURE__ */ React.createElement("article", { className: "content", id: "content-start" }, contentBlocks.length > 0 && /* @__PURE__ */ React.createElement(CmsContentBlocks, { contentBlocks }))
  );
};
const CmsContentLayout$1 = withEditableContent(CmsContentLayout);
export {
  CmsContentLayout,
  CmsContentLayout$1 as default
};
//# sourceMappingURL=Content.js.map
